import { Component, OnInit, ViewChild } from '@angular/core';
import { Utils } from './../../../common/utils';
import { GenericService } from 'src/app/services/generic/generic.service';
import { urlUpload, url_ws, valorAnd, valorOr } from 'src/app/config/config';
import { Table } from 'primeng/table';
import { environment } from 'src/environments/environment';
import { ImageBaseService } from '../../../services/imagenes/imagenes.service';
import * as html2canvas from 'html2canvas';
import { SortEvent } from 'primeng/api';
import { createPdfListOfertasPack } from './pdf/generatedOffertPack';

import * as FileSaver from 'file-saver';
import * as Exceljs from 'exceljs';

const h2c: any = html2canvas;

@Component({
  selector: 'app-ofertas-pack-list',
  templateUrl: './ofertas-pack-list.component.html',
  styleUrls: ['./ofertas-pack-list.component.css']
})
export class OfertasPackListComponent implements OnInit {

  @ViewChild('dt') dt: Table;

  public cols = [
    { header: 'Foto', field: 'foto', width: '60px' },
    { header: 'Nombre', field: 'nombre' },

  ];

  public colsOffer = [
    { field: 'imagen', header: 'Foto' },
    { field: 'nombre', header: 'Artículo' },
    { field: 'articulos', header: 'Mix Paket' }
  ]

  public es = Utils.es;

  public urlUploadArticulo = urlUpload + "/sets/";

  public expression = false;
  public display: boolean = true;

  public calculando: boolean = false;

  public title = "Ofertas Packs";
  public control: any = [];
  public mostrar = false;
  public showOferta: boolean = false;
  public hayOferta: boolean = false;
  public logoUrl = environment.logoUrl;

  public database = "wsets";

  public selectedColumns: any[];
  public anchoTabla = "1500px";
  public showTables: boolean = true;

  public selectedProducts: any[] = [];
  public buscador: string = '';
  public auxitems: any[];

  public isGeneratingCanvas: boolean = false;

  public fecha_actual: string = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear();

  public clientes = {
    selected: null,
    values: [],
    filtered: [],
    label: 'Clientes...'
  };

  public oferta: Oferta = {};
  public tituloEnAleman: boolean;
  public logoBase64: any;

  constructor(
    private genericService: GenericService,
    private imageBaseService: ImageBaseService
  ) {

    this.showCols();

  }

  showCols() {
    this.showTables = true;

    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }


  ngOnInit(): void {

    this.iniciar();

    let interval = setInterval(async () => {

      if (localStorage.getItem("CLIENT_SELECTED")) {
        this.clientes.selected = localStorage.getItem("CLIENT_SELECTED");
      }
      clearInterval(interval)
    });


  }

  iniciar() {
    this.mostrar = false;
    this.cargaClientes();

    this.imageBaseService.image64(url_ws + "upload/resources/logo.jpg").subscribe((data: any) => {
      this.logoBase64 = data;
    })

    this.genericService.getListSimple(this.database).toPromise().then((data: any) => {

      this.control = data.productos;
      this.auxitems = [...this.control];

      this.mostrarTabla();

    }).catch(error => {
      console.error("Error", error);
    });
  }

  cargaClientes() {
    this.genericService.getListSimple('clientes', 'nombre').toPromise().then((data: any) => {
      const relClientes = data.productos;
      relClientes.forEach(element => {


        this.clientes.filtered.push(
          {
            label: element.nombre + ' ' + element.departamento,
            value: element.id,
            domicilio: element.direccion,
            pais: element.pais,
            cp: element.cp,
            poblacion: element.localidad,
            provincia: element.provincia,
            telefono: element.telefono,
            condicion: element.condicion == null ? 0 : element.condicion,
            tipo_precio: element.tipo_precio_facturacion,
            precio_cc_transporte: element.precio_cc_transporte == null ? 0 : element.precio_cc_transporte,
            precio_camion_completo: element.precio_camion_completo == null ? 0 : element.precio_camion_completo
          });
      });


    }).catch(error => {
      console.log("Error", error);
    });

  }

  mostrarTabla() {
    this.mostrar = true;
  }

  cerrar() {
    this.display = false;
    this.expression = false;
  }

  closeWindow(event) {
    this.cerrar();
  }


  public mydt: any;


  cambios(dt) {

    this.mydt = dt;

  }


  buscadorEspecial(value: string) {

    this.control = [...this.auxitems];

    if (value == null || value == undefined || value.length <= 0) {
      this.control = [...this.auxitems];
    } else {
      if (value.includes(valorAnd)) {
        let valores = value.split(valorAnd);
        let control = [];
        for (let index = 0; index < valores.length; index++) {
          if (this.comprobarSiHayValorDefinido(valores[index])) {
            const element = valores[index];
            control = this.buscadorSimple(element);
            this.control = this.quitarDuplicados(control);
          }
        }
      } else if (value.includes(valorOr)) {
        let valores = value.split(valorOr);
        this.control = this.quitarDuplicados(this.buscadorCompuesto(valores));
      } else {
        let control = this.quitarDuplicados(this.buscadorSimple(value))
        this.control = control;
      }
    }
    this.mydt = this.dt;
  }

  buscadorSimple(value: string) {
    let control = [];
    for (let index = 0; index < this.control.length; index++) {
      const element = this.control[index];
      for (const iterator in element) {
        //console.log('iterator', this.control[index][iterator]);
        if (this.comprobarSiHayValorDefinido(this.control[index][iterator])) {
          //console.log('value si hay valor', this.control[index][iterator].toString().toLowerCase(), value.toLowerCase());
          if ((this.control[index][iterator].toString()).toLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), "").includes(value.toLocaleLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), ""))) {
            /*  console.log(this.control[index][iterator],value); */

            control.push(this.control[index]);
          }
        }

      }
    }

    return control;
  }
  
  comprobarSiHayValorDefinido(value): boolean {
    if (value == null || value == undefined || value.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  quitarDuplicados(etiquetas: any[]) {
    let item = [];
    let discriminador = true;
    for (let index = 0; index < etiquetas.length; index++) {
      etiquetas[index].id;
      for (let index2 = 0; index2 < item.length; index2++) {
        if (item[index2].id == etiquetas[index].id) {
          discriminador = false;
        } else {
          discriminador = true;
        }

      }
      if (discriminador) {
        item.push(etiquetas[index]);
      } else {
        discriminador = true;
      }
    }
    return item;
  }

  buscadorCompuesto(value: string[]) {
    let control = [];
    for (let index = 0; index < this.control.length; index++) {
      const element = this.control[index];
      for (const iterator in element) {
        //console.log('iterator', this.control[index][iterator]);
        if (this.comprobarSiHayValorDefinido(this.control[index][iterator])) {
          //console.log('value si hay valor', this.control[index][iterator], value);
          for (let index2 = 0; index2 < value.length; index2++) {
            const element2 = value[index2];
            if (this.comprobarSiHayValorDefinido(element2)) {
              if ((this.control[index][iterator] as string).toLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), "").includes(element2.toLocaleLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), ""))) {
                /*  console.log(this.control[index][iterator],value); */
                control.push(this.control[index]);
              }
            }

          }

        }

      }
    }

    return control;
  }

  public scrollToTop(event: any) {
    const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');
    if (elements && elements[0]) {
      setTimeout(() => {
        elements[0].scrollTop = 0;
      }, 100);
    }
  }

  public decimalFormat(input: any, nDecimals?: number, millar?: string, comma?: string, progressiveTo?: number) {
    if (!input) {
      return '';
    }
    return Utils.decimalFormat(input, nDecimals, millar, comma, progressiveTo);
  }

  public getPrintConfig() {
    const config = {
      canvasScale: 1,
      orientation: 'landscape',
      width: 190,
      height: 290
    };
    return config;
  }

  // Antigua forma de imprimir pdf con canvas -> problema es que si la pantalla donde se visualiza la tabla se corta 

  // public async imprimirReceta() {

  //   this.calculando = true;
  //   this.isGeneratingCanvas = true;
  //   const config = this.getPrintConfig();

  //   h2c(document.getElementById('html2canvasDivOferta'), { scale: config.canvasScale, logging: false }).then(canvas => {
  //     this.isGeneratingCanvas = false;
  //     const pdf = new jsPDF(config.orientation, 'mm', 'a4');
  //     const data = canvas.toDataURL('image/png');
  //     if (canvas.width > canvas.height) {
  //       pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
  //     } else {
  //       pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
  //     }
  //     pdf.save(
  //       'Oferta'
  //     );

  //   });
  //   this.calculando = false;

  // }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;

      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

  /**
   * Funcion que proporciona los datos para descargar la oferta y tambien mostrar en la ventan emergente
   * @returns Objeto
   */
  async creaOferta() {

    this.calculando = true;
    if (this.clientes.selected.length == 0 || this.clientes.selected == null) {
      this.showOferta = false;
      alert('Debe selecionar un cliente');
      return;
    } else if (this.clientes.selected != localStorage.getItem("CLIENT_SELECTED")) {
      localStorage.setItem("CLIENT_SELECTED", this.clientes.selected);
    }


    const idCliente = this.clientes.selected;

    this.clientes.filtered.forEach(element => {

      if (element.value == idCliente) {

        this.oferta.nombre = element.label;
        this.oferta.direccion = element.domicilio;
        this.oferta.cp = element.cp;
        this.oferta.poblacion = element.poblacion;
        this.oferta.provincia = element.provincia;
        this.oferta.pais = element.pais;
        this.oferta.telefono = element.telefono;
        this.oferta.condicion = element.condicion;
        this.oferta.precio_camion_competo = element.precio_camion_completo;
        this.oferta.tipo_precio = element.tipo_precio.substr(0, 3);
        this.oferta.precio_cc_transporte = element.precio_cc_transporte;
      }
    });

    this.oferta.packs = [];

    //Recogemos las ofertas seleccionadas
    for (let index = 0; index < this.selectedProducts.length; index++) {
      const element = this.selectedProducts[index];

      let image64 = '';
      let ancho: number = 150;
      let alto: number = 80;

      if (element.archivo1) {
        if (element.archivo1.trim().length > 0) {
          element.archivo1 = element.archivo1.replace(/ /g, '%20');
          image64 = await this.imageBaseService.image64(urlUpload + 'sets/' + element.archivo1).toPromise();
          image64 = image64.replace("data:image/jpg;base64", "data:image/png;base64");

          let resp = await this.imageBaseService.getDimensionImage(urlUpload + 'sets/' + element.archivo1);
          if (resp.height > resp.width) {
            ancho = 80;
            alto = 150;
          }
        }

      };

      let pack: OfertaPack = {
        nombre: element.nombre,
        imagen: image64,
        observaciones: element.observaciones,
        ancho,
        alto,
        articulos: []
      }

      //Recogemos los articulos de la ofertas seleccionadas
      for (let index = 0; index <= 10; index++) {

        if (element["articulo" + index]) {

          let relImagen = { imagen: '', ancho: 0, alto: 0 };
          let ofertaArticulo: OfertaArticulo = {
            maceta: element["maceta" + index],
            proveedor: element["proveedor" + index],
            nombre: element["articulo" + index],
            descripcion: element["descripcion" + index],
            cantidad: element["cantidad" + index],
            imagen: (await relImagen).imagen,
            precio: element["precio" + index],
            unidades_cc: element["unidades_cc" + index],
            ancho: (await relImagen).ancho,
            alto: (await relImagen).alto,
            precio_neto_vivero: element["precio_neto_vivero" + index],
            precio_etiqueta_articulo: element["precio_etiqueta_articulo" + index],
            precio_comision_articulo: element["precio_comision_articulo" + index],
            precio_comision_carro: element["precio_comision_carro" + index],
            unidades_piso: element["unidades_piso" + index],
            precio_transporte: element["precio_transporte" + index]
          }
          ofertaArticulo.precio = this.oferta.tipo_precio === 'EXV' ? this.getPrecioEXV(ofertaArticulo) : this.oferta.tipo_precio === 'FCA' ? this.getPrecioFCA(ofertaArticulo, this.oferta) : this.getPrecioDDP(ofertaArticulo, this.oferta);
          ofertaArticulo.precio = ofertaArticulo.precio.toString().replace('.',',');
          pack.articulos.push(ofertaArticulo);
        }
      }

      this.oferta.packs.push(pack);
    }

    this.showOferta = true;
    this.calculando = false;
  }

  /**
   * Funcion que imprime el PDF del listado de articulos de la oferta 
   */
  async printPDF() {
    this.calculando = true;
    let logo = await this.imageBaseService.image64(environment.serverUrl + this.logoUrl).toPromise();
    this.tituloEnAleman = true;

    createPdfListOfertasPack(logo, this.oferta, this.fecha_actual);
    this.tituloEnAleman = false;
    this.calculando = false;

  }

  /**
   * 
   * @param urlImagen Nombre de la imagen guardada en el articulo
   * @param ancho Ancho de la imagen
   * @param alto Alto de la imagen
   * @param imagen Esto de puede eliminar si existiera el caso de no utilizar
   * @returns La imagen transformada en formato BASE64 para poder mostrar en la descarga
   */
  async getImage(urlImagen, ancho, alto, imagen) {
    urlImagen = urlImagen.replace(/ /g, '%20');

    imagen = await this.imageBaseService.image64(urlUpload + 'articulos/' + urlImagen).toPromise();
    let resp = await this.imageBaseService.getDimensionImage(urlUpload + 'articulos/' + urlImagen);
    if (resp.height > resp.width) {
      ancho = 80;
      alto = 150;
    }
    return { imagen, ancho, alto };
  }

  getPrecioEXV(articulo: OfertaArticulo): string {

    let precio: number = Number(articulo.precio_neto_vivero) * 1.1;
    precio = precio + Number(articulo.precio_etiqueta_articulo);

    if (Number(articulo.precio_comision_articulo) != 0) {
      precio = Number(articulo.unidades_cc) != 0 ? precio + (Number(articulo.precio_comision_articulo) / Number(articulo.unidades_cc)) : precio;
    } else {
      precio = Number(articulo.unidades_cc) != 0 ? precio + (Number(articulo.precio_comision_carro) / Number(articulo.unidades_cc)) : precio;
    }
    precio = Number(articulo.unidades_cc) != 0 ? precio + (Number(articulo.precio_transporte) / Number(articulo.unidades_cc)) : precio;

    return precio.toFixed(2);

  }

  getPrecioFCA(articulo: OfertaArticulo, oferta: Oferta): string {
    const precioEXV = Number(this.getPrecioEXV(articulo));
    let precio = precioEXV + (precioEXV * Number(oferta.condicion) / 100); // Number(this.getPrecioEXV(articulo)) * Number(oferta.condicion) / 100;

    return precio.toFixed(2);
  }

  getPrecioDDP(articulo: OfertaArticulo, oferta: Oferta): string {

    const pcc = Number(oferta.precio_camion_competo);
    const ucc = Number(articulo.unidades_cc);
    const pcct = Number(oferta.precio_cc_transporte);

    let precio: number = pcc != 0 ? pcc : ucc != 0 ? pcct / ucc : 0
    precio = precio + Number(this.getPrecioFCA(articulo, oferta));
    return precio.toFixed(2);
  }

  generateExcel() {

    // Creo el libro excel
    const wb = new Exceljs.Workbook();
    wb.created = new Date();
    wb.creator = "VPE";


    // Creo una hoja en blanco
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup: { paperSize: 9, orientation: 'landscape' }
    });


    //Añado el logo
    const logo = wb.addImage({ base64: this.logoBase64, extension: 'png' });
    ws.addImage(logo, { tl: { col: 0.1125, row: 0.4 }, ext: { width: 400, height: 120 }, editAs: 'oneCell' });

    //Recogo la posicion donde van a ir la informacion de cabecera
    const rowInfoName = ws.getRow(8);
    const rowInfoDirection = ws.getRow(9);
    const rowInfoCP = ws.getRow(10);
    const rowInfoProvince = ws.getRow(11);
    const rowInfoCountry = ws.getRow(12);
    const rowInfoTel = ws.getRow(13);

    const headerCellNumber = 8;

    //Añado la informacion del cliente
    this.oferta.nombre.length > 0 ? rowInfoName.getCell(headerCellNumber).value = this.oferta.nombre : '';
    this.oferta.direccion.length > 0 ? rowInfoDirection.getCell(headerCellNumber).value = this.oferta.direccion : '';
    this.oferta.cp.length > 0 ? rowInfoCP.getCell(headerCellNumber).value = this.oferta.cp : '';
    this.oferta.provincia.length > 0 ? rowInfoProvince.getCell(headerCellNumber).value = this.oferta.provincia : '';
    this.oferta.pais.length > 0 ? rowInfoCountry.getCell(headerCellNumber).value = this.oferta.pais : '';
    this.oferta.telefono.length > 0 ? rowInfoTel.getCell(headerCellNumber).value = this.oferta.telefono : '';

    ws.addRow([this.fecha_actual])
    ws.addRow(['DETALLE ARTÍCULOS']);

    const headersTable: any = ['Foto', 'Pack', 'MixPaket'];

    const headersTableArticle = []
    headersTableArticle[3] = 'Proveedor'
    headersTableArticle[4] = 'Nombre'
    headersTableArticle[5] = 'Descripcion'
    headersTableArticle[6] = 'Maceta'
    headersTableArticle[7] = 'Stk/Mix'
    headersTableArticle[8] = 'Stk/cc'
    headersTableArticle[9] = 'Preis EXW'

    ws.insertRow(17, headersTable);

    const row = ws.getRow(17);
    row.eachCell({ includeEmpty: true }, (cell => {
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.font = { bold: true, size: 12, color: { 'theme': 1 }, name: 'Calibri', family: 2, scheme: 'minor' }
    }));

    ws.mergeCells('C17:I17');

    for (let i = 0; i < this.oferta.packs.length; i++) {
      const element = this.oferta.packs[i];
      let countRow = 18;

      headersTableArticle[2] = element.nombre;
      ws.insertRow(countRow, headersTableArticle);

      let row = ws.getRow(countRow);
      row.eachCell({ includeEmpty: true }, (cell => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true};
        cell.font = { bold: true, size: 12, color: { 'theme': 1 }, name: 'Calibri', family: 2, scheme: 'minor' }
      }));

      var imgId = wb.addImage({base64: element.imagen, extension: 'png'});
      ws.addImage(imgId,{tl:{col: 0.2, row: (countRow+i) },ext: {width: 100,height:100}});

      let rowArticle = [];      
      
      for (let y = 0; y < element.articulos.length; y++) {
        const article = element.articulos[y];
        rowArticle[3] = article.proveedor
        rowArticle[4] = article.nombre
        rowArticle[5] = article.descripcion
        rowArticle[6] = article.maceta
        rowArticle[7] = article.cantidad
        rowArticle[8] = article.unidades_cc
        rowArticle[9] = article.precio
        
        let c_row = countRow + 1;
        ws.insertRow(c_row, rowArticle);
        
      }
      countRow += (element.articulos.length + 1);

    }


    ws.getColumn('A').width = 35

    //  Funcion que hace que las tengan el tamaño del contenido 
    ws.columns.forEach(function (column, i) {
      let maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        var columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });

    // Genero el archivo XLSX 
    wb.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, `oferta.xlsx`);
    });
  }
}

export interface OfertaArticulo {
  proveedor?: string;
  nombre?: string;
  color?: string;
  tamanyo?: string;
  precio_neto_vivero?: string;
  precio_etiqueta_articulo?: string;
  precio_comision_articulo?: string;
  precio_comision_carro?: string;
  unidades_cc?: string;
  unidades_piso?: string;
  precio_transporte?: string;
  precio?: string;
  cantidad?: number;
  imagen?: string;
  ancho?: number;
  alto?: number;
  descripcion?: string;
  maceta?: string;
  codcli?: string;
}


export interface OfertaPack {
  imagen?: string;
  nombre?: string;
  ancho?: number;
  alto?: number;
  observaciones?: string;
  articulos?: OfertaArticulo[];
}

export interface Oferta {
  nombre?: string;
  direccion?: string;
  cp?: string;
  poblacion?: string;
  provincia?: string;
  pais?: string;
  telefono?: string;
  condicion?: string;
  tipo_precio?: string;
  precio_cc_transporte?: string;
  precio_camion_competo?: string;
  articulos?: OfertaArticulo[];
  packs?: OfertaPack[];
}
